import React, {useContext, useEffect, useState} from "react";
import {useFormik} from "formik";
import Button from "../Button";
import BottomButtonWrapper from "../BottomButtonWrapper";
import * as Yup from "yup";
import Select from 'react-select'
import Api from "../../tools/service";
import Swal from "sweetalert2";
import {RadioGroup} from "../RadioGroup";
import {FaHome, FaUser} from "react-icons/fa";
import Switch from "react-switch";
import Discount from "./Discount"
import {Reoverlay} from "reoverlay";
import EstateGuideModal from "../modals/EstateGuideModal";
import EstateGuideImage1 from "../../images/estate/estate_guide_1.webp"
import EstateGuideImage2 from "../../images/estate/estate_guide_2.webp"
import EstateGuideImage3 from "../../images/estate/estate_guide_3.webp"
const guideSlides=[
    {
        title:'سند تک برگ جدید',
        description:'اطلاعات مورد نیاز مطابق تصویر در کادر قرمز مشخص شده است.',
        status:true,
        image:EstateGuideImage1
    },
    {
        title:'سند تک برگ قدیمی',
        description:'اطلاعات مورد نیاز مطابق تصویر در کادر قرمز مشخص شده است.',
        status:true,
        image:EstateGuideImage2
    },
    {
        title:'سند دفترچه‌ای',
        description:'این سند غیر قابل استعلام است.',
        status:false,
        image:EstateGuideImage3
    }
]
const InitConfirm = ({handleConfirm,handleGetProcess, accessToken, processInfo}) => {
    const [showDiscount,setShowDiscount]=useState(true)
    const [step, setStep] = useState(0)
    const [provinceLoading, setProvinceLoading] = useState(true);
    const [unitLoading, setUnitLoading] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    useEffect(async () => {
        handleGetProvince()
    }, [])

    const handleGenerateUuid = async (type) => {
        try {
            const response = await Api.post('/api/v1/Providers/GenUuidV2', {
                request_type: type,
                callback_url: "https://venesh.ir"
            }, {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            if (response && !response.hasError) {

                return response.data.uuid;
            } else {

                Swal.fire({
                    text: response.message,
                    title: "ناموفق",
                    icon: 'error',
                    backdrop: true,
                    focusConfirm: false,
                    showCancelButton: false,
                    confirmButtonColor: '#d51e3e',
                    confirmButtonText: 'تلاش مجدد',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,


                }).then((result) => {


                });

                throw new Error(response.message)
            }
        } catch (error) {
            console.log(error)

        } finally {

        }
    };
    const handleGetProvince = () => {
        setProvinceLoading(true)
        handleGenerateUuid('EstateProvinces').then(uuid => {
            Api.get('/api/v1/Fronts/EstateProvinces', {
                params: {
                    uuid,
                }
            }).then(response => {

                if (!response.hasError) {
                    const newArray = response.data.map(({Id: value, Name: label}) => ({
                        value: value.value,
                        label: label.value
                    }));
                    setProvince(newArray)
                    setProvinceLoading(false)
                }
            }).catch(e => {
                setProvinceLoading(false)
            }).finally(() => {


            })
        }).catch(e => {
            console.log(e)
        })
    }
    const [province, setProvince] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null)
    const [selectedUnitId, setSelectedUnitId] = useState(null)
    const [documentType, setDocumentType] = useState(processInfo?.confirmed_data?.DocumentType ? processInfo?.confirmed_data?.DocumentType : 'New');
    const documentValidation = Yup.object().shape({
        province: Yup.string().required('فیلد استان الزامیست.'),
        unitId: Yup.string().required(' فیلدواحد ثبتی الزامیست.'),
        basic: Yup.string().required('فیلد اصلی الزامیست.'),
        secondary: Yup.string().required('فیلد فرعی الزامیست.'),
        pageNumber: Yup.string().when('radioOption', {
            is: (value) => {

                return value === 'Old'
            },
            then: (schema) => schema.required('فیلد شماره صفحه الزامیست.'),
            otherwise: (schema) => schema,
        }),
        officeNumber: Yup.string().when('radioOption', {
            is: (value) => {

                return value === 'Old'
            },
            then: (schema) => schema.required('فیلد شماره صفحه الزامیست.'),
            otherwise: (schema) => schema,
        }),
        uniqueId: Yup.string().when('radioOption', {
            is: (value) => {

                return value === 'New'
            },
            then: (schema) => schema.required('فیلد شناسه یکتا سند / شماره دفتر املاک الکترونیکی الزامیست.'),
            otherwise: (schema) => schema,
        }),


    });
    const [showAccessToOwnerSwitch, setShowAccessToOwnerSwitch] = useState(true)
    const [isOwner, setIsOwner] = useState(!!processInfo.im_owner)
    const [accessToOwner, setAccessToOwner] = useState(!!processInfo.i_have_access_to_owner&&!processInfo.im_owner)
    const userValidation = Yup.object().shape({
        nid: Yup.string().required('فیلد کد ملی الزامیست.').min(10, 'فیلد کد ملی یا شناسه ملی حداقل ۱۰ رقم می باشد.').max(11, 'فیلد کد ملی یا شناسه ملی حداکثر ۱۰ رقم می باشد.'),
        ownerMobile: accessToOwner ?   Yup.string().matches(/^(09|۰۹)[0-9۰-۹]{9}$/, 'شماره موبایل نامعتبر می‌باشد.').required('شماره موبایل الزامیست.') : null

    });

    const onProvinceChange = (data) => {
        setUnitLoading(true)
        setSelectedProvince(data)
        formik.setFieldValue(
            'province',
            data.value,
        )
        setSelectedUnitId('')
        handleGenerateUuid('EstateUnits').then((uuid) => {
            Api.get('/api/v1/Fronts/EstateUnits', {
                params: {
                    uuid,
                    ProvinceId: data.value,
                }
            }).then(response => {

                if (!response.hasError) {
                    const newArray = response.data.map(({Id: value, Name: label}) => ({
                        value: value.value,
                        label: label.value
                    }));

                    setUnitList(newArray)
                } else {

                }
            }).catch(e => {

            }).finally(() => {
                setUnitLoading(false)
            })
        })
    }
    const onUnitChange = (e) => {
        setSelectedUnitId(e)
        formik.setFieldValue(
            'unitId',
            e.value,
        )
    }
    const handleUserInfo = (values) => {
        const data={
            im_owner:isOwner,
            i_have_access_to_owner:accessToOwner,
            nid:values.nid,
            mobile:accessToOwner? values.ownerMobile:null,
        }

        setUserInfo(data);
        setStep(step + 1);

    }
    const handleSubmit = (values) => {
        const data={...userInfo, documentType, ...values};
        handleConfirm(data)
    }
    const userFormik = useFormik({
        initialValues: {
            nid: processInfo?.confirmed_data?.NationalId || '',
            ownerMobile: accessToOwner ?  processInfo?.confirmed_data?.Mobile: ''
        },
        validationSchema: userValidation,
        onSubmit: handleUserInfo
    });
    const formik = useFormik({
        initialValues: {
            province: '',
            radioOption: processInfo?.confirmed_data?.DocumentType ? processInfo?.confirmed_data?.DocumentType : 'New',
            unitId: '',
            ...(documentType === "New" && {uniqueId: processInfo?.confirmed_data?.UniqueId ? processInfo?.confirmed_data?.UniqueId : ''}),
            ...(documentType === "Old" && {
                officeNumber: processInfo?.confirmed_data?.OfficeNumber ? processInfo?.confirmed_data?.OfficeNumber : '',
                pageNumber: processInfo?.confirmed_data?.PageNumber ? processInfo?.confirmed_data?.PageNumber : ''
            }),
            basic: processInfo?.confirmed_data?.Basic ? processInfo?.confirmed_data?.Basic : '',
            secondary: processInfo?.confirmed_data?.Secondary ? processInfo?.confirmed_data?.Secondary : '',

        },
        validationSchema: documentValidation,
        onSubmit: handleSubmit
    });
    const handleOwner = (value) => {
        setShowAccessToOwnerSwitch(!value)
        if (value) {
            setAccessToOwner(false)
        }
        setIsOwner(value)
    }
    const handleAccessToOwner = (value) => {
        setAccessToOwner(value);
        setIsOwner(false)

    }
    const handleChangeDocumentType = (type) => {

        formik.setFieldValue('radioOption', type);
        setDocumentType(type);

    }

    useEffect(() => {
        if(processInfo?.has_reset){
            setShowDiscount(false)
        }
    }, [[processInfo]]);
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: 'none',
            padding: '3px',
            backgroundColor: 'rgb(243, 244, 246)',
            borderRadius: '0.75rem'
        }),
        input: (provided, state) => ({
            ...provided,
            borderRadius: '17px',
            // Add your custom styles for the input here
            color: 'red', // Example: Change text color to red
        }),
    };
    const handleShowGuide=()=>{
        Reoverlay.showModal(EstateGuideModal,{
            slides:guideSlides,

        })
    }
    if(showDiscount){
        return <Discount getProcess={handleGetProcess} token={accessToken}  processInfo={processInfo} onClick={()=>setShowDiscount(false)}   />
    }
    return <div className="w-11/12 sm:w-10/12  md:w-8/10 lg:w-8/12 xl:w-4/12 mb-28   bg-white p-5 mx-auto mt-5 rounded-lg">

        {step === 0 && <form onSubmit={userFormik.handleSubmit} className="w-full ">
            <div className="mb-3 border-b flex flex-col justify-center items-center  pb-3">
                <div className=" p-3 border-2 border-green-300 rounded-full bg-green-500 bg-opacity-20">
                    <FaUser className="text-green-500 text-3xl "/>
                </div>
                <h1 className="mt-3 text-sm font-bold ">اطلاعات مالک ملک را وارد کنید.</h1>
            </div>
            <div className="w-full flex mt-4 flex-col">
                <label className="text-sm" htmlFor="nid">کد ملی مالک </label>
                <input dir="ltr" onChange={userFormik.handleChange} value={userFormik.values.nid} type="tel"
                       className="w-full bg-gray-100  text-sm text-right mt-1 rounded-lg p-3"
                       placeholder="کد ملی مالک  را وارد کنید"
                       name="nid"/>
                {userFormik.errors.nid && userFormik.touched.nid ? (
                    <p className="text-red-400 text-sm font-light  ">{userFormik.errors.nid}</p>
                ) : null}
                <div className="grid grid-cols-1 mt-3 ">
                    <div onClick={() => {
                        handleOwner(!isOwner)
                    }} className="w-full  justify-between p-3   flex items-center">
                        <span className="text-sm">مالک ملک هستم.</span>
                        <Switch onColor="#36b570" height={20} width={40} uncheckedIcon={false} checkedIcon={false}
                                checked={isOwner}
                                onChange={handleOwner}/>
                    </div>
                    {showAccessToOwnerSwitch && <div onClick={() => {
                        handleAccessToOwner(!accessToOwner)
                    }} className="w-full  p-3  justify-between mt-3 border-t   flex items-center">
                        <span className="text-sm">به مالک دسترسی دارم.</span>
                        <Switch onColor="#36b570" height={20} width={40} uncheckedIcon={false} checkedIcon={false}
                                checked={accessToOwner}
                                onChange={handleAccessToOwner}/>
                    </div>}
                    {accessToOwner && <div className="border-t py-3 mt-3">
                        <label className="text-sm" htmlFor="ownerMobile">موبایل مالک </label>
                        <input dir="ltr" onChange={userFormik.handleChange} value={userFormik.values.ownerMobile} type="tel"
                               className="w-full bg-gray-100  text-sm text-right mt-1 rounded-lg p-3"
                               placeholder="موبایل مالک را وارد کنید"
                               name="ownerMobile"/>
                        {userFormik.errors.ownerMobile && userFormik.touched.ownerMobile ? (
                            <p className="text-red-400 text-sm font-light  ">{userFormik.errors.ownerMobile}</p>
                        ) : null}
                    </div>}
                </div>
            </div>
            <div className="bg-blue-50 border-2 border-blue-200 text-blue-500 flex justify-between items-center rounded text-sm p-3 my-2 ">
                <span> تنها اسناد ملکی تک‌برگ قابل استعلام هستند.</span>
                <button onClick={handleShowGuide} type="button" className="text-sm  px-4 py-2 rounded-lg bg-white"  >راهنما</button>
            </div>
            <BottomButtonWrapper grid={processInfo?.has_reset ? 1:2}>
                {!processInfo?.has_reset &&   <Button onClick={()=>setShowDiscount(true)} type="button" rounded="rounded-lg" className="w-full text-sm  flex justify-center items-center"
                                                     theme="link"><span>مرحله قبل</span>
                </Button>}
                <Button type="submit" rounded="rounded-lg" className="w-full text-sm  flex justify-center items-center"
                        theme="green"><span>مرحله بعد</span>
                </Button>
            </BottomButtonWrapper>
        </form>}

        {step === 1 && <form onSubmit={formik.handleSubmit} className="w-full  ">
            <div className="mb-3 border-b flex flex-col justify-center items-center  pb-3">
                <div className=" p-3 border-2 border-green-300 rounded-full bg-green-500 bg-opacity-20">
                    <FaHome className="text-green-500 text-3xl "/>
                </div>
                <h1 className="mt-3 text-sm font-bold">اطلاعات ملک را وارد کنید.</h1>
            </div>
            <div
                className="bg-blue-50 border-2 border-blue-200 text-blue-500 flex justify-between items-center rounded text-sm p-3 my-2 ">
                <span> تنها اسناد ملکی تک‌برگ قابل استعلام هستند.</span>
                <button onClick={handleShowGuide} type="button"
                        className="text-sm  px-4 py-2 rounded-lg bg-white">راهنما
                </button>
            </div>
            <div className="w-full   ">
                <div className="w-full grid mt-2 grid-cols-1 lg:grid-cols-2 gap-2 ">
                    <div>
                        <label className="text-sm" htmlFor="province">استان</label>
                        <Select
                            loadingMessage={() => <div>لطفا منتظر بمانید</div>}
                            defaultValue={selectedProvince}
                            onChange={onProvinceChange}
                            options={province}
                            value={selectedProvince}
                            isLoading={provinceLoading}
                            placeholder={'استان '}
                            noOptionsMessage={() => {
                                return <>موردی یافت نشد</>
                            }}
                            styles={customStyles}
                            className="text-sm"
                            isRtl={true}
                            name="province"
                            isSearchable={true}
                        />
                        {formik.errors.province && formik.touched.province ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.province}</p>
                        ) : null}
                    </div>
                    <div>
                        <label className="text-sm" htmlFor="UnitId">واحد ثبتی</label>
                        <Select
                            defaultValue={selectedUnitId}
                            onChange={onUnitChange}
                            isLoading={unitLoading}
                            options={unitList}
                            loadingMessage={() => <div>لطفا منتظر بمانید</div>}
                            value={selectedUnitId}
                            placeholder={'واحد ثبتی'}
                            noOptionsMessage={() => {
                                return <>موردی یافت نشد</>
                            }}
                            name="unitId"
                            styles={customStyles}
                            className="text-sm"
                            isRtl={true}
                            isSearchable={true}
                        />
                        {formik.errors.unitId && formik.touched.unitId ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.unitId}</p>
                        ) : null}
                    </div>
                </div>
                <div className="w-full grid gap-2 mt-2 grid-cols-2 ">
                    <div className="w-full flex flex-col">
                        <label className="text-sm mb-1" htmlFor="basic">اصلی </label>
                        <input dir="ltr" onChange={formik.handleChange} value={formik.values.basic} type="tel"
                               className="w-full bg-gray-100  text-right text-sm rounded-lg p-3" placeholder="اصلی"
                               name="basic"/>
                        {formik.errors.basic && formik.touched.basic ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.basic}</p>
                        ) : null}
                    </div>
                    <div className="w-full flex flex-col">
                        <label className="text-sm " htmlFor="secondary">فرعی</label>
                        <input dir="ltr" onChange={formik.handleChange} value={formik.values.secondary} type="tel"
                               className="w-full bg-gray-100 text-sm text-right rounded-lg p-3" placeholder="فرعی"
                               name="secondary"/>
                        {formik.errors.secondary && formik.touched.secondary ? (
                            <p className="text-red-400 text-sm font-light  ">{formik.errors.secondary}</p>
                        ) : null}
                    </div>
                </div>
                <div className=" w-full xl:w-6/12 ">
                    <p className="text-sm mt-2 mb-1">نوع سند را انتخاب کنید</p>
                    <RadioGroup selectedIndex={documentType === 'Old' ? 1 : 0} handleChange={handleChangeDocumentType}
                                items={[
                                    {
                                        value: "New",
                                        text: "جدید"
                                    },
                                    {
                                        value: "Old",
                                        text: "قدیمی"
                                    }
                                ]}/>
                </div>

            </div>
            <div className="grid grid-cols-1 mt-2 w-full gap-3 ">
                {documentType === "New" &&
                    <div className="grid grid-cols-1 mt-2  gap-2">

                        <div className="flex flex-col">
                            <label className="text-sm" htmlFor="uniqueId">شناسه یکتا سند / شماره دفتر املاک
                                الکترونیکی</label>
                            <input dir="ltr" onChange={formik.handleChange} value={formik.values.uniqueId} type="tel"
                                   className="w-full bg-gray-100 text-sm  text-right rounded-lg p-3"
                                   placeholder="شناسه یکتا سند / شماره دفتر املاک الکترونیکی"
                                   name="uniqueId"/>
                            {formik.errors.uniqueId && formik.touched.uniqueId ? (
                                <p className="text-red-400 text-sm font-light  ">{formik.errors.uniqueId}</p>
                            ) : null}
                        </div>
                    </div>}
                {documentType === "Old" &&
                    <div className="grid grid-cols-2 mt-2  gap-2">

                        <div className="flex flex-col">
                            <label className="text-sm" htmlFor="officeNumber">شماره دفتر </label>
                            <input dir="ltr" onChange={formik.handleChange} value={formik.values.officeNumber}
                                   type="tel" className="w-full text-sm bg-gray-100  text-right rounded-lg p-3"
                                   placeholder="شماره دفتر"
                                   name="officeNumber"/>
                            {formik.errors.officeNumber && formik.touched.officeNumber ? (
                                <p className="text-red-400 text-sm font-light  ">{formik.errors.officeNumber}</p>
                            ) : null}
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm" htmlFor="pageNumber">شماره صفحه</label>
                            <input dir="ltr" onChange={formik.handleChange} value={formik.values.pageNumber} type="tel"
                                   className="w-full bg-gray-100  text-sm text-right rounded-lg p-3"
                                   placeholder="شماره صفحه"
                                   name="pageNumber"/>
                            {formik.errors.pageNumber && formik.touched.pageNumber ? (
                                <p className="text-red-400 text-sm font-light  ">{formik.errors.pageNumber}</p>
                            ) : null}
                        </div>
                    </div>}
            </div>

            <BottomButtonWrapper grid={2}>
                <Button onClick={() => setStep(0)} type="button" rounded="rounded-lg"
                        className="w-full  text-sm flex justify-center items-center"
                        theme="link"><span>مرحله قبل</span></Button>
                <Button disabled={provinceLoading || unitLoading} type="submit" rounded="rounded-lg"
                        className="w-full text-sm  flex justify-center items-center"
                        theme="green"><span>مرحله بعد</span></Button>

            </BottomButtonWrapper>
        </form>}

    </div>
}
export default InitConfirm;